import { Chip } from 'components/Chip'
import { resolveTagColorClasses } from 'constants/tagColors'

type TagChipProps = {
  name: string
  color: string
  className?: string
  // solid は「この友だちにこのタグが付いている」を表す用途。付与済みの見た目を
  // TagSelector と揃えるため、タグ自体を列挙する画面（タグ管理）の soft と分ける。
  variant?: 'soft' | 'solid'
}

// タグ表示をアプリ全体で統一するための共通コンポーネント（既存 Chip の薄いラッパー）。
export function TagChip({
  name,
  color,
  className = '',
  variant = 'soft',
}: TagChipProps) {
  const classes = resolveTagColorClasses(color)
  const isSolid = variant === 'solid'

  return (
    <Chip
      className={className}
      bgColor={isSolid ? classes.solidBg : classes.bg}
      textColor={isSolid ? 'text-white' : classes.text}
      ringColor={isSolid ? '' : classes.ring}
      filled={isSolid}
      textSize="text-xs"
      padding="px-2 py-0.5"
      rounded="rounded-full"
    >
      {name}
    </Chip>
  )
}
